import { clientService } from '../_services'

const state = {
  currentClient: null,
  // TODO: change clients to be a dict by id
  clients: [],
  filter: null,
  APIFetchStatus: null,  // null, 'fetching'
};

const getters = {
  currentClient: state => state.currentClient,
}

const mutations = {
  setCurrentClient: function (state, client)
  {
    state.currentClient = client
  },
  setClients: function (state, clients)
  {
    state.clients = clients
  },
  updateAPIFetchStatus: function (state, fetchStatus) {
    state.APIFetchStatus = fetchStatus
  },
  updateClientLastConsult: function (state, {clientId, consultData})
  {
    let client = state.clients.find(client => client.id == clientId)
    state.clients[state.clients.indexOf(client)].last_completed_consult = consultData
  },
  setFilter: function (state, filter)
  {
    state.filter = filter
  },
  clearFilter: function (state)
  {
    state.filter = null
  },
  clearCurrentClient: function (state) {
    state.currentClient = null
  }
}

const actions = {
  setCurrentClient: function ({ commit }, client)
  {
    commit('setCurrentClient', client)
  },
  getClients: function ({ commit, state }, payload={})
  {
    commit('updateAPIFetchStatus', 'fetching')

    if (! payload.search && (!state.filter && state.clients.length > 0)) {
      // Dont run a full refresh when we already have the clients loaded
      return
    }

    commit('setClients', [])
    commit('setFilter', payload.search)
    clientService.getClients(payload.search, payload.search_type)
      .then(clients => {
        if (state.APIFetchStatus == 'fetching') {
          commit('setClients', clients)
          commit('updateAPIFetchStatus', null)
        }
      })
  },
  updateClientLastConsult: function ({commit}, { clientId, consultData })
  {
    commit('updateClientLastConsult', { clientId, consultData })
  },
  getClient: function ({ commit }, clientId)
  {
        clientService.getClientConsults(clientId)
            .then(clientData => {
              commit('setCurrentClient', clientData)
            }
        )
  },
  clearFilter: function ({commit, dispatch})
  {
    commit('clearFilter')
    commit('setClients', [])
    return dispatch('getClients')
  },
  clearCurrentClient: function ({commit}) {
    commit('clearCurrentClient')
  }
}



export const client = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};

